import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  TextField, MenuItem, SelectField, FlatButton, RaisedButton, Card, CardText,
  DatePicker, RadioButtonGroup, RadioButton, Dialog, Divider, IconButton,
  Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, Checkbox, CircularProgress,
} from "material-ui";
import DateIcon from "material-ui/svg-icons/action/date-range";
import customDateTimeFormat from "../../../helpers/dateFormat";
import {
  OpenConfirmacionGuardadoAgregacion, CloseConfirmacionGuardadoAgregacion,
  CambiarCodPrestacion, CambiarTipoPrestacion, CambiarGuarismo, CambiarGlosaPrestacionPrestador,
  CambiarInicioVigencia, CambiarPertenenciaFonasa, CambiarCodFonasa,
  CambiarItemImed, CambiarTipoProfesional, GuardarValorPrestaciones,
  CambiarUnidadGrilla, CambiarCheckRows, CambiarUnidadReplicar,
  obtenerValorMaxPrestacion, CambiarMontoAmbulatorio, CambiarMontoAmbulatorioError,
  CambiarMontoHospitalario, CambiarMontoHospitalarioError, DisplayErrorText,
  GuardarArbolInicial, LimpiarErroresGrilla, ValidarPrestacionExiste,
  LoadingValidaCodIsapreFonasa, validaCodIsapreFonasa, ValidarGuarismo,
  LimpiarCodIsapreFonasa, LimpiarPrestacion, AddErrorToPrestacion, ChangeFonasaInAllPrests, RemoveErrorToPrestacion, CheckForFonasaErrorsInPrests, CleanErrorsInPrests,
} from "./actions";
import { ObtenerTiposUnidad, ObtenerItemImed, ObtenerTipoProfesional, ObtenerPertenenciaFonasa, ObtenerTiposPrestacionesIsapre }
  from "../../Global/actions";
import { CerrarNuevaPrestacion } from "../FiltroBusqueda/actions";
import { AddPrestacionSolicitud } from "../GrillaSolicitud/actions";
import guid from "../../../helpers/guid";
import banmedicaTheme from "./../../../config/banmedicaTheme";
import styles from "../../styles/styles";
import valorUnidad from "../../../helpers/valorUnidad";

class NuevaPrestacionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      LoadingValidarPrestacionExiste: false,
      showCodigoFonasa: true,
      infoAlert: false,
      infoMensaje: "",
      prestacionesExistentes: [],
      prestacionesNoExistentes: [],
      itemImedNoPermitidos: [],
      fonasaCodeLengthMessage: "",
      showErrorUnidad: false,
    };
  }

  componentWillMount() {
    this.props.dispatch(GuardarArbolInicial(this.props.tiposArancel, this.props.centrosAtencion));

    this.props.dispatch(ObtenerTiposPrestacionesIsapre());
    this.props.dispatch(ObtenerTiposUnidad());
    this.props.dispatch(ObtenerItemImed());
    this.props.dispatch(ObtenerTipoProfesional());
    this.props.dispatch(ObtenerPertenenciaFonasa());
    this.props.dispatch(obtenerValorMaxPrestacion());
  }

  showInfoAlert = (mensaje) => {
    this.setState({ infoAlert: true, infoMensaje: mensaje });
  }

  validarRepetida = (prestacionnueva) => {
    let sw = false;
    this.props.prestacionesSolicitud.forEach((prestacion) => {
      if (prestacion.CENTRO_AT === prestacionnueva.CENTRO_AT
        && prestacion.RUTARANCEL === prestacionnueva.RUTARANCEL
        && prestacion.COD_PRESTADOR === prestacionnueva.COD_PRESTADOR
        && prestacion.PROF_CCOD === prestacionnueva.PROF_CCOD
        && prestacion.TIPO_ATENCION === prestacionnueva.TIPO_ATENCION) {
        sw = true;
      }
    });
    return sw;
  };

  CerrarNuevaPrestacion = () => {
    this.props.dispatch(CerrarNuevaPrestacion());
  }

  LimpiarFormulario = () => {
    this.props.dispatch(LimpiarPrestacion());
    this.setState({ showCodigoFonasa: true });
    this.props.dispatch(ValidarGuarismo(true));
    this.componentWillMount();
  }

  OpenConfirmacionGuardadoAgregacion = () => {
    this.props.dispatch(OpenConfirmacionGuardadoAgregacion());
  };

  CloseConfirmacionGuardadoAgregacion = () => {
    this.props.dispatch(CloseConfirmacionGuardadoAgregacion());
  };

  CambiarCodPrestacion = (event) => {
    this.props.dispatch(CambiarCodPrestacion(event.target.value));
  }

  CambiarTipoPrestacion = (event, index, value) => {
    const desc = this.props.tiposPrestaciones.filter((p) => p.Id === value)[0].Descripcion;
    this.props.dispatch(CambiarTipoPrestacion(value, desc));
    if (this.props.ENV.GRUPOS_NO_VALIDAN_GUARISMO.includes(value)/*  && this.props.ENV.PROFESIONALES_NO_VALIDAN_GUARISMO.includes(this.props.detallePrestacion.tipoProfesional) */) {
      this.props.dispatch(ValidarGuarismo(false));
    } else {
      this.props.dispatch(ValidarGuarismo(true));
    }

    this.setState({ itemImedNoPermitidos: [] });
    if (this.props.ENV.GRUPOS_NO_VALIDAN_ITEMIMED.map((p) => p.IdGrupo).includes(value)) {
      const itemImedNo = this.props.ENV.GRUPOS_NO_VALIDAN_ITEMIMED.filter((p) => p.IdGrupo === value)[0].ItemImed;
      this.setState({ itemImedNoPermitidos: itemImedNo });
      if (itemImedNo.includes(this.props.detallePrestacion.itemImed)) {
        this.props.dispatch(CambiarItemImed(null, "Item IMED no permitido para el grupo"));
      }
    }
  }

  CambiarGuarismo = (event) => {
    const re = /^([0-9]|1[0-4])$/; // 0 a 14
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarGuarismo(event.target.value));
    }
  }

  CambiarInicioVigencia = (event, date) => {
    /* const dateMin = new Date(Date.now());
    dateMin.setDate(dateMin.getDate() + 15);
    dateMin.setHours(0, 0, 0, 0);
    let dateMod = date;
    if (dateMin > date) {
      dateMod = dateMin;
      this.props.dispatch(CambiarInicioVigencia(
        dateMod,
        `Valor no puede ser menor a ${dateMin.toLocaleDateString()}`
      ));
    } else { */
    this.props.dispatch(CambiarInicioVigencia(date /* dateMod */));
    /* } */
  }

  CambiarGlosaPrestacionPrestador = (event) => {
    this.props.dispatch(CambiarGlosaPrestacionPrestador(event.target.value));
  }

  CambiarPertenenciaFonasa = (event, value) => {
    switch (value) {
      case 1:
      case "1":
      case 2:
      case "2":
        this.setState({ showCodigoFonasa: true });
        break;
      case 3:
      case "3":
        this.setState({ showCodigoFonasa: false });
        this.props.dispatch(CheckForFonasaErrorsInPrests());
        this.props.dispatch(CambiarCodFonasa(null));
        this.props.dispatch(LimpiarCodIsapreFonasa(null));

        if (this.props.tipoUnidadReplicar == 'VE') this.setState({ showErrorUnidad: true });
        else this.setState({ showErrorUnidad: false });

        break;
      default:
        this.setState({ showCodigoFonasa: true });
    }
    this.props.dispatch(CambiarPertenenciaFonasa(value));
  }

  CambiarCodFonasa = (event) => {
    const re = /^[0-9]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(LoadingValidaCodIsapreFonasa(true));
      this.props.dispatch(CambiarCodFonasa(event.target.value));
      this.props.dispatch(validaCodIsapreFonasa());
    }
  }

  CambiarItemImed = (event, index, value) => {
    if (this.state.itemImedNoPermitidos.includes(value)) {
      this.props.dispatch(CambiarItemImed(null, "Item IMED no permitido para el grupo"));
    } else {
      this.props.dispatch(CambiarItemImed(value));
    }
  }

  CambiarTipoProfesional = (event, index, value) => {
    /* if (this.props.ENV.PROFESIONALES_NO_VALIDAN_GUARISMO.includes(value) && this.props.ENV.GRUPOS_NO_VALIDAN_GUARISMO.includes(this.props.detallePrestacion.tipoPrestacion)) {
      this.props.dispatch(ValidarGuarismo(false));
    } else {
      this.props.dispatch(ValidarGuarismo(true));
    } */

    this.props.dispatch(CambiarTipoProfesional(value));
  }

  CambiarCheckRows = (event, checked, rutArancel, centroAtencion) => {
    this.props.dispatch(CambiarCheckRows(checked, rutArancel, centroAtencion));
  }

  CambiarUnidadGrilla = (unidad, tipoAtencion, rutArancel, centroAtencion, valor, idArrPrestacion) => {
    if (unidad == "VE" && (this.props.detallePrestacion.pertenenciaFonasa == "3" || this.props.detallePrestacion.pertenenciaFonasa == null)) {
      this.props.dispatch(AddErrorToPrestacion(idArrPrestacion, unidad, tipoAtencion));
    } else {
      this.props.dispatch(RemoveErrorToPrestacion(idArrPrestacion));
      const validacion = valorUnidad.Validar(valor, unidad);
      this.props.dispatch(GuardarValorPrestaciones(`${validacion.valor}`, validacion.error, tipoAtencion, rutArancel, centroAtencion));
      this.props.dispatch(CambiarUnidadGrilla(unidad, "", tipoAtencion, rutArancel, centroAtencion));
    }
  }

  CambiarUnidadRep = (unidad, valorHosp, valorAmb) => {
    if (unidad == "VE" && (this.props.detallePrestacion.pertenenciaFonasa == "3" || this.props.detallePrestacion.pertenenciaFonasa == null)) {
      this.setState({ showErrorUnidad: true });
      this.props.dispatch(ChangeFonasaInAllPrests());
    } else {
      this.setState({ showErrorUnidad: false });
      this.props.dispatch(CambiarUnidadReplicar(unidad));
      this.CambiarValorHospitalarioEvent(unidad, valorHosp);
      this.CambiarValorAmbulatorioEvent(unidad, valorAmb);
    }
  }

  GuardarValorArancel = (punidad, tipoAtencion, rutArancel, centroAtencion, valor) => {
    const validacion = valorUnidad.Validar(valor, punidad);
    this.props.dispatch(GuardarValorPrestaciones(validacion.valor, validacion.error, tipoAtencion, rutArancel, centroAtencion));
  }

  CambiarValorHospitalarioEvent = (unidad, valor) => {
    this.props.dispatch(CambiarMontoHospitalarioError(""));

    const validacion = valorUnidad.Validar(valor, unidad);
    if (validacion.error) {
      this.props.dispatch(CambiarMontoHospitalarioError(validacion.error));
    }
    this.props.dispatch(CambiarMontoHospitalario(validacion.valor));
  }

  CambiarValorAmbulatorioEvent = (unidad, valor) => {
    this.props.dispatch(CambiarMontoAmbulatorioError(""));
    const validacion = valorUnidad.Validar(valor, unidad);
    if (validacion.error) {
      this.props.dispatch(CambiarMontoAmbulatorioError(validacion.error));
    }

    this.props.dispatch(CambiarMontoAmbulatorio(validacion.valor));
  }

  ValidacionPrestacionesYaExistentes = () => {
    const prestSeleccionadas = this.props.prestacionesSeleccionadas.filter((p) => p.Selected);
    this.setState({ LoadingValidarPrestacionExiste: true });

    const prestValidar = [];
    prestSeleccionadas.forEach((prest) => {
      if (prest.ValorA) {
        prestValidar.push({
          rutArancel: prest.rutArancel,
          centroAtencion: prest.centroAtencion,
          codigoPrestacionPrestador: this.props.detallePrestacion.codigoPrestacionPrestador,
          tipoAtencion: "A",
          tipoProfesional: this.props.detallePrestacion.tipoProfesional,
          inicioVigenciaArancel: this.props.detallePrestacion.inicioVigenciaArancel,
          //tipoPrestacion : this.props.detallePrestacion.tipoPrestacion,
        });
      }
      if (prest.ValorH) {
        prestValidar.push({
          rutArancel: prest.rutArancel,
          centroAtencion: prest.centroAtencion,
          codigoPrestacionPrestador: this.props.detallePrestacion.codigoPrestacionPrestador,
          tipoAtencion: "H",
          tipoProfesional: this.props.detallePrestacion.tipoProfesional,
          inicioVigenciaArancel: this.props.detallePrestacion.inicioVigenciaArancel,
          //tipoPrestacion : this.props.detallePrestacion.tipoPrestacion,
        });
      }
    });

    this.props.dispatch(ValidarPrestacionExiste(
      prestValidar,
      (prestacionesExist, prestacionesNoExist) => {
        this.setState({ LoadingValidarPrestacionExiste: false });
        this.setState({ prestacionesExistentes: [] });
        this.setState({ prestacionesNoExistentes: [] });
        const prestacionesExistC = [];
        const prestacionesNoExistC = [];
        if (prestacionesExist && prestacionesExist.length > 0) {
          prestacionesExist.forEach((prestExistente) => {
            this.props.prestacionesSeleccionadas
              .filter((p) => p.Selected
                && p.centroAtencion === prestExistente.CentroMedico && p.rutArancel === prestExistente.RutArancel)
              .forEach((prest) => {
                prestacionesExistC.push({
                  Descripcion: `${prest.DescArancel} / ${prest.DescCentro} / ${prestExistente.TipoAtencion}`,
                  TipoAtencion: prestExistente.TipoAtencion,
                  CentroMedico: prestExistente.CentroMedico,
                  RutArancel: prestExistente.RutArancel,
                });
              });
          });
          prestacionesNoExist.forEach((prnoe) => {
            this.props.prestacionesSeleccionadas
              .filter((p) => p.Selected
                && p.centroAtencion === prnoe.CentroMedico && p.rutArancel === prnoe.RutArancel)
              .forEach((prest) => {
                prestacionesNoExistC.push({
                  Descripcion: `${prest.DescArancel} / ${prest.DescCentro} / ${prnoe.TipoAtencion}`,
                  TipoAtencion: prnoe.TipoAtencion,
                  CentroMedico: prnoe.CentroMedico,
                  RutArancel: prnoe.RutArancel,
                });
              });
          });
          this.setState({ prestacionesNoExistentes: prestacionesNoExistC });
          this.setState({ prestacionesExistentes: prestacionesExistC });
        } else {
          this.props.dispatch(OpenConfirmacionGuardadoAgregacion());
        }
      }
    ));
  }

  GuardarAgregacionSolicitud = () => {
    this.props.dispatch(LimpiarErroresGrilla());

    const CodPrestacion = this.props.detallePrestacion.codigoPrestacionPrestador;
    const GlosaPrestacion = this.props.detallePrestacion.glosaPrestacionPrestador;
    const CodProfesional = this.props.detallePrestacion.tipoProfesional;
    const InicioVigenciaArancel = this.props.detallePrestacion.inicioVigenciaArancel;
    const TipoPrestacion = this.props.detallePrestacion.tipoPrestacion;
    const PabellonPrestacion = this.props.detallePrestacion.pabellonPrestacion;
    const PertenenciaFonasa = this.props.detallePrestacion.pertenenciaFonasa;
    const CodigoFonasa = this.props.detallePrestacion.codigoFonasa;
    const ItemImed = this.props.detallePrestacion.itemImed;

    const errors = {
      codigoPrestacionPrestadorErr: "",
      GlosaPrestacionErr: "",
      CodProfesionalErr: "",
      InicioVigenciaArancelErr: "",
      TipoPrestacionErr: "",
      PabellonPrestacionErr: "",
      PertenenciaFonasaErr: "",
      CodigoFonasaErr: "",
      ItemImedErr: "",
    };

    let exit = false;

    if (!CodPrestacion) {
      this.codigoPrestacionPrestador.focus();
      errors.codigoPrestacionPrestadorErr = "Falta Código Prestación";
    }
    if (!GlosaPrestacion) {
      this.glosaPrestacion.focus();
      errors.GlosaPrestacionErr = "Ingresar Glosa ";
    }
    if (!CodProfesional) {
      errors.CodProfesionalErr = "Seleccionar Profesional ";
    }
    if (!TipoPrestacion) {
      errors.TipoPrestacionErr = "Seleccionar Prestación";
    }
    if (!PabellonPrestacion && this.props.validarGuarismo) {
      this.guarismo.focus();
      errors.PabellonPrestacionErr = "Seleccionar Guarismo de DP o Sala de Procedimientos";
    }
    if (!InicioVigenciaArancel) {
      errors.InicioVigenciaArancelErr = "Seleccionar Inicio de Vigencia";
    }
    if (!PertenenciaFonasa) {
      errors.PertenenciaFonasaErr = "Seleccionar Pertenencia a Fonasa";
    }
    if ((!CodigoFonasa || this.props.detallePrestacion.codigoFonasaValid === false) && this.state.showCodigoFonasa) {
      this.codigoFonasa.focus();
      errors.CodigoFonasaErr = "Debe ingresar código Fonasa válido";
    }
    if (ItemImed === "" || ItemImed == null) {
      errors.ItemImedErr = "Debe Seleccionar Item Imed";
    }

    // validar errores
    if (Object.values(errors).filter((message) => !!message).length > 0) {
      this.props.dispatch(DisplayErrorText(errors));
      // return;
      exit = true;
    }

    this.props.prestacionesSeleccionadas.filter((p) => p.Selected).forEach((prestacion) => {
      if (this.props.valorMaxPres.length > 0) {
        const ValorMax = Number(this.props.valorMaxPres[0].Nombre);
        if (Number(prestacion.ValorH) > ValorMax) {
          this.props.dispatch(GuardarValorPrestaciones(
            prestacion.ValorH, "El Valor Supera lo maximo permitido para una prestación",
            "H", prestacion.rutArancel, prestacion.centroAtencion
          ));
          exit = true;
        }
        if (Number(prestacion.ValorA) > ValorMax) {
          this.props.dispatch(GuardarValorPrestaciones(
            prestacion.ValorA, "El Valor Supera lo maximo permitido para una prestación",
            "A", prestacion.rutArancel, prestacion.centroAtencion
          ));
          exit = true;
        }
      }

      if (!prestacion.ValorH && !prestacion.ValorA) {
        this.props.dispatch(GuardarValorPrestaciones(prestacion.ValorH, "Debe Agregar Valor", "H", prestacion.rutArancel, prestacion.centroAtencion));
        this.props.dispatch(GuardarValorPrestaciones(prestacion.ValorA, "Debe Agregar Valor", "A", prestacion.rutArancel, prestacion.centroAtencion));

        exit = true;
      }
      if (prestacion.ValorH && !prestacion.UnidadH) {
        this.props.dispatch(CambiarUnidadGrilla(prestacion.UnidadH, "Seleccionar Tipo Unidad", "H", prestacion.rutArancel, prestacion.centroAtencion));

        exit = true;
      }
      if (prestacion.ValorA && !prestacion.UnidadA) {
        this.props.dispatch(CambiarUnidadGrilla(prestacion.UnidadA, "Seleccionar Tipo Unidad", "A", prestacion.rutArancel, prestacion.centroAtencion));

        exit = true;
      }
    });

    if (!exit) {
      this.ValidacionPrestacionesYaExistentes();
    }
  }

  guardarAgregacionSolicitudQuitandoExistentes = () => {
    for (let i = 0; i < this.state.prestacionesExistentes.length; i += 1) {
      this.props.dispatch(GuardarValorPrestaciones(
        null,
        "",
        this.state.prestacionesExistentes[i].TipoAtencion,
        this.state.prestacionesExistentes[i].RutArancel,
        this.state.prestacionesExistentes[i].CentroMedico,
      ));
    }

    this.guardarAgregacionSolicitudFinal();
  }

  guardarAgregacionSolicitudFinal = () => {
    const CodPrestacion = this.props.detallePrestacion.codigoPrestacionPrestador;
    const GlosaPrestacion = this.props.detallePrestacion.glosaPrestacionPrestador;
    const GlosaPrestacionIsapre = this.props.detallePrestacion.glosaPrestacionIsapre;
    const CodProfesional = this.props.detallePrestacion.tipoProfesional;
    const InicioVigenciaArancel = this.props.detallePrestacion.inicioVigenciaArancel;
    const TipoPrestacion = this.props.detallePrestacion.tipoPrestacion;
    const PabellonPrestacion = this.props.validarGuarismo ? this.props.detallePrestacion.pabellonPrestacion : null;
    const PertenenciaFonasa = this.props.detallePrestacion.pertenenciaFonasa;
    const CodigoFonasa = this.props.detallePrestacion.codigoFonasa;
    const ItemImed = this.props.detallePrestacion.itemImed;

    let hasduplicado = false;
    if (this.props.prestacionesSeleccionadas.filter((p) => p.Selected).length > 0) {
      this.props.prestacionesSeleccionadas.filter((p) => p.Selected).forEach((prestacion) => {
        const ValorHospPres = prestacion.ValorH;
        const TipoUnidadHosp = prestacion.UnidadH;

        if (prestacion.ValorH) {
          if (this.state.prestacionesExistentes && this.state.prestacionesExistentes
            .filter((p) => p.CentroMedico === prestacion.centroAtencion && p.RutArancel === prestacion.rutArancel && p.TipoAtencion === "H").length > 0) {
            return;
          }
          const prestacion1 = {
            COD_PRESTADOR: CodPrestacion,
            GLOSA_CODPRESTADOR: GlosaPrestacion,
            GLOSA_GRUPO_PRESTACION: GlosaPrestacionIsapre,
            PROF_CCOD: CodProfesional,
            VALOR: ValorHospPres,
            UNIDAD: TipoUnidadHosp,
            TIPO_ATENCION: "H",
            INICIO_VIG: InicioVigenciaArancel,
            FECHA_FIN_VIG: null,
            TIPO_PRESTACION: TipoPrestacion,
            GUARISMO: PabellonPrestacion,
            PERTENENCIA_FONASA: PertenenciaFonasa,
            CODIGO_FONASA: CodigoFonasa,
            ITEM_IMED: ItemImed,
            CENTRO_AT: prestacion.DescCentro,
            SECUENCIA: prestacion.centroAtencion,
            ARANCEL: prestacion.DescArancel,
            RUTARANCEL: prestacion.rutArancel,
            OPERACION: "Crea",
            COD_OPERACION: "1",
            GUID: guid.new(),
          };

          if (this.validarRepetida(prestacion1)) {
            hasduplicado = true;
          } else {
            this.props.dispatch(AddPrestacionSolicitud(prestacion1));
          }
        }

        const ValorAmbPres = prestacion.ValorA;
        const TipoUnidadAmb = prestacion.UnidadA;

        if (prestacion.ValorA) {
          if (this.state.prestacionesExistentes && this.state.prestacionesExistentes
            .filter((p) => p.CentroMedico === prestacion.centroAtencion && p.RutArancel === prestacion.rutArancel && p.TipoAtencion === "A").length > 0) {
            return;
          }
          const prestacion2 = {
            COD_PRESTADOR: CodPrestacion,
            GLOSA_CODPRESTADOR: GlosaPrestacion,
            GLOSA_GRUPO_PRESTACION: GlosaPrestacionIsapre,
            PROF_CCOD: CodProfesional,
            VALOR: ValorAmbPres,
            UNIDAD: TipoUnidadAmb,
            TIPO_ATENCION: "A",
            INICIO_VIG: InicioVigenciaArancel,
            FECHA_FIN_VIG: null,
            TIPO_PRESTACION: TipoPrestacion,
            GUARISMO: PabellonPrestacion,
            PERTENENCIA_FONASA: PertenenciaFonasa,
            CODIGO_FONASA: CodigoFonasa,
            ITEM_IMED: ItemImed,
            CENTRO_AT: prestacion.DescCentro,
            SECUENCIA: prestacion.centroAtencion,
            ARANCEL: prestacion.DescArancel,
            RUTARANCEL: prestacion.rutArancel,
            OPERACION: "Crea",
            COD_OPERACION: "1",
            GUID: guid.new(),
          };

          if (this.validarRepetida(prestacion2)) {
            hasduplicado = true;
          } else {
            this.props.CambiosSinGuardar(true);
            this.props.dispatch(AddPrestacionSolicitud(prestacion2));
          }
        }
      });
    }
    this.props.dispatch(CloseConfirmacionGuardadoAgregacion());
    this.CerrarNuevaPrestacion();
    if (hasduplicado) {
      this.showInfoAlert("Algunas prestaciones ya estaban agregadas");
    }
  }

  ReplicarValoresArancel = () => {
    if (this.props.detallePrestacion.pertenenciaFonasa != '3' || this.props.tipoUnidadReplicar != 'VE') {
      this.props.dispatch(CleanErrorsInPrests());
    }

    this.props.prestacionesSeleccionadas.filter((p) => p.Selected).forEach((prestacion) => {
      this.props.dispatch(GuardarValorPrestaciones(this.props.valorHosp, "", "H", prestacion.rutArancel, prestacion.centroAtencion));
      this.props.dispatch(CambiarUnidadGrilla(this.props.tipoUnidadReplicar, "", "H", prestacion.rutArancel, prestacion.centroAtencion));

      this.props.dispatch(GuardarValorPrestaciones(this.props.valorAmb, "", "A", prestacion.rutArancel, prestacion.centroAtencion));
      this.props.dispatch(CambiarUnidadGrilla(this.props.tipoUnidadReplicar, "", "A", prestacion.rutArancel, prestacion.centroAtencion));
    });
  }

  render() {
    const { REACT_APP_REAJUSTAR_ARANCEL_FECHA_VIGENCIA_MINIMA: fechaVigenciaPrestador } = this.props.ENV;
    let today = new Date();
    today.setDate(today.getDate() + fechaVigenciaPrestador);
    const minDate = today;

    const actionsAgregacion = [
      <FlatButton
        label="Aun no estoy listo. Seguir modificando"
        primary
        onClick={this.CloseConfirmacionGuardadoAgregacion}
      />,
      <FlatButton
        label="Agregar"
        primary
        onClick={this.guardarAgregacionSolicitudFinal}
      />,
    ];

    const actionsAgregacionConExistentes = [
      <FlatButton
        label="Cancelar"
        primary
        onClick={() => { this.setState({ prestacionesExistentes: [] }); this.setState({ prestacionesNoExistentes: [] }); }}
      />,
      <FlatButton
        label="Agregar"
        primary
        onClick={this.guardarAgregacionSolicitudQuitandoExistentes}
      />,
    ];

    const actionsAgregacionTodasExistentes = [
      <FlatButton
        label="Aceptar"
        primary
        onClick={() => { this.setState({ prestacionesExistentes: [] }); this.setState({ prestacionesNoExistentes: [] }); }}
      />,
    ];

    const listPrestExistentes = [];
    const listPrestNoExistentes = [];
    if (this.state.prestacionesExistentes) {
      this.state.prestacionesNoExistentes.forEach((element) => {
        listPrestNoExistentes.push(<li key={`${guid.new()}`} ><span>{element.Descripcion}</span></li>);
      });
      this.state.prestacionesExistentes.forEach((element) => {
        listPrestExistentes.push(<li key={`${guid.new()}`} ><span>{element.Descripcion}</span></li>);
      });
    }

    const menuListItemImed = [];
    if (this.props.itemsImed) {
      this.props.itemsImed.forEach((element) => {
        menuListItemImed.push(<MenuItem key={element.Item} value={element.Item} primaryText={element.Descripcion} style={styles.customWidth} />);
      });
    }

    const menuListPermanenciaFonasa = [];
    if (this.props.pertenenciasFonasa) {
      this.props.pertenenciasFonasa.forEach((element) => {
        menuListPermanenciaFonasa.push(<RadioButton key={element.Simbolo} value={element.Simbolo} label={element.Descripcion} style={styles.customWidth} />);
      });
    }

    const menuListTipoPrestaciones = [];
    if (this.props.tiposPrestaciones) {
      this.props.tiposPrestaciones.forEach((element) => {
        if (element.Id.toString() !== "0") {
          menuListTipoPrestaciones.push(<MenuItem key={element.Id} value={element.Id} primaryText={`${element.TipoAtencion}: ${element.Descripcion}`} style={styles.customWidth} />);
        }
      });
    }

    const menuListTipoProfesional = [];
    if (this.props.tiposProfesionales) {
      this.props.tiposProfesionales.forEach((element) => {
        menuListTipoProfesional.push(<MenuItem key={element.Tipo} value={element.Tipo} primaryText={element.Descripcion} style={styles.customWidth} />);
      });
    }

    const menuListUnidadReplicar = [];
    if (this.props.tiposUnidad) {
      this.props.tiposUnidad.forEach((uni) => {
        menuListUnidadReplicar.push(<MenuItem key={uni.Unidad} value={uni.Unidad} primaryText={uni.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListUnidadArbol = [];
    if (this.props.tiposUnidad) {
      this.props.tiposUnidad.forEach((uni) => {
        menuListUnidadArbol.push(<MenuItem key={`unidad_${uni.Unidad}`} value={uni.Unidad} primaryText={uni.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const tableArbol = [];

    if (this.props.tiposArancel && this.props.centrosAtencion) {
      const checkAll = (this.props.prestacionesSeleccionadas.length ===
        this.props.prestacionesSeleccionadas.filter((p) => p.Selected).length);

      tableArbol.push((
        <Checkbox
          label="Seleccionar Todo"
          id="Selectall"
          key="checkboxTodosCentroAtencion"
          onCheck={this.CambiarCheckRows}
          checked={checkAll}
          style={styles.customWidth}
        />));
      this.props.tiposArancel.forEach((arancel) => {
        const arbolTipoArancel = [];
        this.props.centrosAtencion.forEach((centro) => {
          const rowState = this.props.prestacionesSeleccionadas
            .filter((p) => p.rutArancel === arancel.Rut && p.centroAtencion === centro.Secuencia);
          const prestacion = rowState && rowState.length > 0 ? rowState[0] : null;
          arbolTipoArancel.push((
            <TableRow key={`rowCentroAtencion_${arancel.Rut}_${centro.Secuencia}`} style={{ height: 40 }}>
              <TableHeaderColumn style={styles.rowPrestacionTablaInferiorCheckSub} />
              <TableHeaderColumn style={styles.rowPrestacionTablaInferiorCheckSub}>
                <i className="material-icons">subdirectory_arrow_right</i>
              </TableHeaderColumn>
              <TableRowColumn style={styles.rowPrestacionTablaInferiorCheckCC}>
                <Checkbox
                  key={`checkboxCentroAtencion_${arancel.Rut}_${centro.Secuencia}`}
                  onCheck={(event, checked) => this.CambiarCheckRows(null, checked, arancel.Rut, centro.Secuencia)}
                  checked={prestacion && prestacion.Selected}
                />
              </TableRowColumn>
              <TableRowColumn style={styles.rowPrestacionTablaInferior0} title={centro.Descripcion}>{centro.Descripcion}</TableRowColumn>
              <TableRowColumn style={styles.rowPrestacionTablaInferior1}>
                <div style={styles.floatingClaseSelect2} key={`text_A_${arancel.Rut}_${centro.Secuencia}`}>Valor Ambulatorio</div>
                <TextField
                  name={`txt_amb_${arancel.Rut}_${centro.Secuencia}`}
                  id={`txt_amb_${arancel.Rut}_${centro.Secuencia}`}
                  key={`txt_amb_${arancel.Rut}_${centro.Secuencia}`}
                  value={(prestacion && prestacion.ValorA) || ""}
                  onChange={(event) => this.GuardarValorArancel((prestacion && prestacion.UnidadA), "A", arancel.Rut, centro.Secuencia, event.target.value)}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFieldNuevaPrestacionTablaInferior}
                  errorText={(prestacion && prestacion.ValorAError) || ""}
                  errorStyle={styles.errorStyle}
                />
              </TableRowColumn>
              <TableRowColumn style={styles.rowPrestacionTablaInferior2}>
                <div style={styles.floatingClaseSelect2} key={`textU_A_${arancel.Rut}_${centro.Secuencia}`}>Unidad</div>
                <SelectField
                  name={`dd_amb_${arancel.Rut}_${centro.Secuencia}`}
                  id={`dd_amb_${arancel.Rut}_${centro.Secuencia}`}
                  key={`dd_amb_${arancel.Rut}_${centro.Secuencia}`}
                  value={prestacion && prestacion.UnidadA}
                  errorText={prestacion && prestacion.UnidadAError}
                  onChange={(event, index, value) => this.CambiarUnidadGrilla(value, "A", arancel.Rut, centro.Secuencia, ((prestacion && prestacion.ValorA) || ""), prestacion && this.props.prestacionesSeleccionadas.indexOf(prestacion))}
                  labelStyle={styles.h4}
                  underlineStyle={styles.underlineSelectField}
                  style={styles.selectFieldNuevaPrestacionTablaInferior}
                  iconStyle={styles.iconSelectField}
                  menuItemStyle={styles.menuItemStyleSelectField}
                  selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                  errorStyle={styles.errorStyle}
                  errorText={prestacion && (prestacion.hasAnError && "Si se utiliza la unidad VECES FONASA, debe indicar pertenencia fonasa válida.")}
                >{menuListUnidadArbol}
                </SelectField>
              </TableRowColumn>
              <TableRowColumn style={styles.rowPrestacionTablaInferior1}>
                <div style={styles.floatingClaseSelect2} key={`text_H_${arancel.Rut}_${centro.Secuencia}`}> Valor Hospitalario </div>
                <TextField
                  name={`txt_hosp_${arancel.Rut}_${centro.Secuencia}`}
                  id={`txt_hosp_${arancel.Rut}_${centro.Secuencia}`}
                  key={`txt_hosp_${arancel.Rut}_${centro.Secuencia}`}
                  value={(prestacion && prestacion.ValorH) || ""}
                  onChange={(event) => this.GuardarValorArancel((prestacion && prestacion.UnidadH), "H", arancel.Rut, centro.Secuencia, event.target.value)}
                  underlineStyle={styles.underlineSelectField}
                  inputStyle={styles.h4}
                  style={styles.selectFieldNuevaPrestacionTablaInferior}
                  errorText={(prestacion && prestacion.ValorHError) || ""}
                  errorStyle={styles.errorStyle}
                />
              </TableRowColumn>
              <TableRowColumn style={styles.rowPrestacionTablaInferior2}>
                <div style={styles.floatingClaseSelect2} key={`textU_H_${arancel.Rut}_${centro.Secuencia}`}>Unidad</div>
                <SelectField
                  name={`dd_hosp_${arancel.Rut}_${centro.Secuencia}`}
                  id={`dd_hosp_${arancel.Rut}_${centro.Secuencia}`}
                  key={`dd_hosp_${arancel.Rut}_${centro.Secuencia}`}
                  value={prestacion && prestacion.UnidadH}
                  errorText={prestacion && prestacion.UnidadHError}
                  onChange={(event, index, value) => this.CambiarUnidadGrilla(value, "H", arancel.Rut, centro.Secuencia, ((prestacion && prestacion.ValorH) || ""), prestacion && this.props.prestacionesSeleccionadas.indexOf(prestacion))}
                  labelStyle={styles.h4}
                  underlineStyle={styles.underlineSelectField}
                  style={styles.selectFieldNuevaPrestacionTablaInferior}
                  iconStyle={styles.iconSelectField}
                  menuItemStyle={styles.menuItemStyleSelectField}
                  selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                  errorStyle={styles.errorStyle}
                  errorText={prestacion && (prestacion.hasAnErrorH && "Si se utiliza la unidad VECES FONASA, debe indicar pertenencia fonasa válida.")}
                >{menuListUnidadArbol}
                </SelectField>
              </TableRowColumn>
            </TableRow>
          ));
        });
        const arancelCheckAll = (this.props.prestacionesSeleccionadas.filter((p) => p.rutArancel === arancel.Rut).length ===
          this.props.prestacionesSeleccionadas.filter((p) => p.rutArancel === arancel.Rut && p.Selected).length);
        tableArbol.push((
          <div style={{ width: "930px", overflow: "hidden", textAlign: "center" }} key={`contentArancel_${arancel.Rut}`}>
            <Table
              key={`tableArancel_${arancel.Rut}`}
              title={arancel.Descripcion}
              style={{ width: "930px" }}
              selectable={false}
            >
              <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                <TableRow>
                  <TableHeaderColumn style={styles.rowPrestacionTablaInferiorCheckSub}>
                    <i className="material-icons">subdirectory_arrow_right</i>
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.rowPrestacionTablaInferiorCheckTA}>
                    <Checkbox
                      key={`checkboxArancel_${arancel.Rut}`}
                      onCheck={(event, checked) => this.CambiarCheckRows(null, checked, arancel.Rut)}
                      checked={arancelCheckAll}
                    />
                  </TableHeaderColumn>
                  <TableHeaderColumn style={styles.customWidth100}>{arancel.Descripcion}</TableHeaderColumn>
                </TableRow>

              </TableHeader>
              <TableBody
                displayRowCheckbox={false}
                deselectOnClickaway={false}
              // stripedRows
              >
                {arbolTipoArancel}
              </TableBody>
            </Table>
          </div>
        ));
      });
    }

    const cantPrestacionesAgregar = this.props.prestacionesSeleccionadas.filter((p) => p.Selected && p.ValorH).length +
      this.props.prestacionesSeleccionadas.filter((p) => p.Selected && p.ValorA).length;

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Nueva Prestación
                  </div>
                  <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect}>Código Prestación Prestador</div>
                  <TextField
                    name="txt_npf_codprestacion"
                    id="txt_npf_codprestacion"
                    ref={(c) => { this.codigoPrestacionPrestador = c; }}
                    value={this.props.detallePrestacion.codigoPrestacionPrestador || ""}
                    onChange={this.CambiarCodPrestacion}
                    maxLength={15}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFiledStyle}
                    errorText={this.props.detallePrestacion.codigoPrestacionPrestadorErr || ""}
                    errorStyle={styles.errorStyle}
                  />
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect}>Tipo de Prestación</div>
                  {
                    this.props.tiposPrestaciones && this.props.tiposPrestaciones.length > 0 ?
                      <SelectField
                        name="dd_npf_tipoPrestacion"
                        id="dd_npf_tipoPrestacion"
                        value={this.props.detallePrestacion.tipoPrestacion}
                        onChange={this.CambiarTipoPrestacion}
                        labelStyle={styles.h4}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.selectFiledStyle}
                        iconStyle={styles.iconSelectField}
                        menuItemStyle={styles.menuItemStyleSelectField}
                        selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                        errorText={this.props.detallePrestacion.tipoPrestacionErr || ""}
                        errorStyle={styles.errorStyle}
                      >
                        {menuListTipoPrestaciones}
                      </SelectField>
                      :
                      <CircularProgress />
                  }
                </div>
                {this.props.validarGuarismo ?
                  <div className="col-4" style={styles.colSelectFieldActualizar}>
                    <div style={styles.floatingClaseSelect}>Guarismo de DP o Sala de Procedimiento</div>
                    <TextField
                      name="txt_npf_guarismo"
                      id="txt_npf_guarismo"
                      ref={(c) => { this.guarismo = c; }}
                      value={this.props.detallePrestacion.pabellonPrestacion || ""}
                      onChange={this.CambiarGuarismo}
                      maxLength={2}
                      underlineStyle={styles.underlineSelectField}
                      inputStyle={styles.h4}
                      style={styles.selectFiledStyle}
                      errorText={this.props.detallePrestacion.pabellonPrestacionErr || ""}
                      errorStyle={styles.errorStyle}
                      minLength={6}
                      maxLength={10}
                      pattern="^([0-9]|1[0-4])$"
                      title="Solo se admiten valores de 0 a 14"
                    />
                  </div>
                  : null}
              </div>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Glosa Prestación Prestador</div>
                  <TextField
                    name="txt_npf_glosaPrestacionPrestador"
                    id="txt_npf_glosaPrestacionPrestador"
                    ref={(c) => { this.glosaPrestacion = c; }}
                    value={this.props.detallePrestacion.glosaPrestacionPrestador || ""}
                    onChange={this.CambiarGlosaPrestacionPrestador}
                    maxLength={200}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFiledStyle}
                    errorText={this.props.detallePrestacion.glosaPrestacionPrestadorErr || ""}
                    errorStyle={styles.errorStyle}
                  />
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Inicio Vigencia</div>
                  <div className="container">
                    <div className="row" >
                      <DatePicker
                        name="dp_npf_inicioVigencia"
                        id="dp_npf_inicioVigencia"
                        mode="landscape"
                        DateTimeFormat={customDateTimeFormat.cl()}
                        locale="es-CL"
                        firstDayOfWeek={1}
                        minDate={minDate}
                        value={this.props.detallePrestacion.inicioVigenciaArancel}
                        onChange={this.CambiarInicioVigencia}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.datepickerStyle}
                        inputStyle={styles.h4}
                        errorText={this.props.detallePrestacion.inicioVigenciaArancelErr || ""}
                        errorStyle={{ bottom: "10px" }}
                      />
                      <DateIcon
                        // iconStyle={{ height: 20, width: 20 }}
                        style={{ marginTop: 3, marginLeft: 5 }}
                        color={banmedicaTheme.palette.accent1Color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Tipo de Profesional</div>
                  {
                    this.props.tiposProfesionales && this.props.tiposProfesionales.length > 0 ?
                      <SelectField
                        name="dd_npf_tipoProfesional"
                        id="dd_npf_tipoProfesional"
                        value={this.props.detallePrestacion.tipoProfesional}
                        onChange={this.CambiarTipoProfesional}
                        labelStyle={styles.h4}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.selectFiledStyle}
                        iconStyle={styles.iconSelectField}
                        menuItemStyle={styles.menuItemStyleSelectField}
                        selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                        errorText={this.props.detallePrestacion.tipoProfesionalErr || ""}
                        errorStyle={styles.errorStyle}
                      >
                        {menuListTipoProfesional}
                      </SelectField>
                      :
                      <CircularProgress />
                  }
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-4">
                  <div style={styles.floatingClaseSelect2}>Pertenencia Fonasa</div>
                  <RadioButtonGroup
                    name="rd_npf_pertenenciaFonasa"
                    id="rd_npf_pertenenciaFonasa"
                    valueSelected={this.props.detallePrestacion.pertenenciaFonasa}
                    onChange={this.CambiarPertenenciaFonasa}
                    style={styles.customWidth}
                  // errorText={this.props.detallePrestacion.pertenenciaFonasaErr || ""}
                  >
                    {menuListPermanenciaFonasa}
                  </RadioButtonGroup>
                  {this.props.detallePrestacion.pertenenciaFonasaErr ?
                    <div style={{ color: "#f44336" }}>{this.props.detallePrestacion.pertenenciaFonasaErr}</div>
                    : null}
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  {this.state.showCodigoFonasa ?
                    <div>
                      <div style={styles.floatingClaseSelect2}>Código Fonasa Informado por Prestador</div>
                      <TextField
                        name="txt_npf_codigoFonasa"
                        id="txt_npf_codigoFonasa"
                        ref={(c) => { this.codigoFonasa = c; }}
                        value={this.props.detallePrestacion.codigoFonasa || ""}
                        onChange={this.CambiarCodFonasa}
                        underlineStyle={styles.underlineSelectField}
                        inputStyle={styles.h4}
                        style={styles.selectFiledStyle}
                        errorText={this.props.detallePrestacion.codigoFonasaErr || ""}
                        errorStyle={styles.errorStyle}
                        maxLength={10}
                      />
                      {this.props.codigoFonasaLoading && !this.props.detallePrestacion.codigoFonasaErr ?
                        <span>
                          <div style={styles.codFonasaLoading}>
                            validando ...
                          </div>
                        </span>
                        :
                        <span>
                          {this.props.detallePrestacion.codigoFonasaValid === true ?
                            <div>
                              <div style={styles.codFonasaValido}>
                                Código válido:
                              </div>
                              <div style={styles.floatingClaseSelect2}>
                                {this.props.detallePrestacion.codigoFonasaGlosa}
                              </div>
                            </div>
                            :
                            null}
                        </span>
                      }
                    </div>
                    : null}
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Item IMED</div>
                  {
                    this.props.itemsImed && this.props.itemsImed.length > 0 ?
                      <SelectField
                        name="dd_npf_itemImed"
                        id="dd_npf_itemImed"
                        value={this.props.detallePrestacion.itemImed}
                        onChange={this.CambiarItemImed}
                        labelStyle={styles.h4}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.selectFiledStyle}
                        iconStyle={styles.iconSelectField}
                        menuItemStyle={styles.menuItemStyleSelectField}
                        selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                        errorText={this.props.detallePrestacion.itemImedErr || ""}
                        errorStyle={styles.errorStyle}
                      >
                        {menuListItemImed}
                      </SelectField>
                      :
                      <CircularProgress />
                  }
                </div>
              </div>
              <div className="row">
                <div className="col-12" style={{ padding: 0, margin: 0 }}>
                  <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Valor Ambulatorio</div>
                  <TextField
                    name="txt_npf_valorAmbu"
                    id="txt_npf_valorAmbu"
                    value={this.props.valorAmb || ""}
                    onChange={(event) => this.CambiarValorAmbulatorioEvent(this.props.tipoUnidadReplicar, event.target.value)}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFieldNuevaPrestacion}
                    errorText={this.props.valorAmbErr}
                    errorStyle={styles.errorStyle}
                  />
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Valor Hospitalario</div>
                  <TextField
                    name="txt_npf_valorHosp"
                    id="txt_npf_valorHosp"
                    value={this.props.valorHosp || ""}
                    onChange={(event) => this.CambiarValorHospitalarioEvent(this.props.tipoUnidadReplicar, event.target.value)}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFieldNuevaPrestacion}
                    errorText={this.props.valorHospErr}
                    errorStyle={styles.errorStyle}
                  />
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Unidad</div>
                  {
                    this.props.tiposUnidad && this.props.tiposUnidad.length > 0 ?
                      <SelectField
                        name="dd_replicar_unidad"
                        id="dd_replicar_unidad"
                        value={this.props.tipoUnidadReplicar}
                        onChange={(event, index, value) => this.CambiarUnidadRep(value, this.props.valorHosp, this.props.valorAmb)}
                        labelStyle={styles.h4}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.selectFieldNuevaPrestacion}
                        iconStyle={styles.iconSelectField}
                        menuItemStyle={styles.menuItemStyleSelectField}
                        selectedMenuItemStyle={styles.selectedMenuItemSelectFiueld}
                        errorStyle={styles.errorStyle}
                        errorText={this.state.showErrorUnidad && "Si se utiliza la unidad VECES FONASA, debe indicar pertenencia fonasa válida."}
                      >
                        {menuListUnidadReplicar}
                      </SelectField>
                      :
                      <CircularProgress />
                  }
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <RaisedButton
                    disabled={!!this.props.valorAmbErr ||
                      !!this.props.valorHospErr}
                    label="Replicar"
                    onClick={this.ReplicarValoresArancel}
                    secondary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{
                      width: "130px", borderRadius: 5, marginLeft: 20, marginTop: 10,
                    }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  {tableArbol}
                </div>
              </div>
              <div className="row">
                <div className="col-12" style={{ textAlign: "right", marginTop: 10, marginBottom: 10 }}>
                  <RaisedButton
                    onClick={this.CerrarNuevaPrestacion}
                    label="Cancelar"
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />
                  <RaisedButton
                    onClick={this.LimpiarFormulario}
                    label="Limpiar"
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "145px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />

                  {this.state.LoadingValidarPrestacionExiste ?
                    <RaisedButton
                      disabled
                      label="Validando ..."
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                    :
                    <RaisedButton
                      disabled={this.props.prestacionesSeleccionadas.filter((p) => p.Selected).length === 0 ||
                        this.props.prestacionesSeleccionadas.filter((p) => p.Selected && (p.ValorHError || p.ValorAError || p.UnidadHError || p.UnidadAError)).length > 0}
                      onClick={this.GuardarAgregacionSolicitud}
                      label="Agregar"
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                  }

                </div>
              </div>
            </CardText>
          </Card>
        </div>

        <Dialog
          key="dialogConfimacionAgregacion"
          id="dialogConfimacionAgregacion"
          actions={actionsAgregacion}
          modal
          open={this.props.aceptaGuardadoModalAgregacion}
          style={{ width: "700px", fontSize: "13px" }}
        >
          {
            cantPrestacionesAgregar > 1 ?
              `Se agregarán ${cantPrestacionesAgregar} prestaciones nuevas según la combinación de Centros Médicos y Aranceles seleccionados`
              :
              "Se agregará 1 prestación nueva según la combinación de Centro Médico y Arancel seleccionado"
          }
        </Dialog>

        {this.state.prestacionesNoExistentes && this.state.prestacionesNoExistentes.length > 0 ?
          <Dialog
            key="dcace"
            id="dcace"
            actions={actionsAgregacionConExistentes}
            modal
            open={this.state.prestacionesExistentes && this.state.prestacionesExistentes.length > 0}
          >
            <div>
              <span>
                La prestación ya existe en algunas de las combinaciones de &quot;Tipo de Arancel&quot; y &quot;Centro de Atención&quot; seleccionadas, por lo tanto no serán incluidas en la solicitud.
              </span>
              <ul style={{ maxHeight: "250px", overflowY: "auto" }}>
                {listPrestExistentes}
              </ul>

              <span>
                Se agregará esta prestación solo en las combinaciones de &quot;Tipo de Arancel&quot; y &quot;Centro de Atención&quot; que se muestran a continuación:
              </span>
              <ul style={{ maxHeight: "250px", overflowY: "auto" }}>
                {listPrestNoExistentes}
              </ul>
              ¿Desea continuar con la solicitud?
            </div>
          </Dialog>
          :
          <Dialog
            key="dcace"
            id="dcace"
            actions={actionsAgregacionTodasExistentes}
            modal
            open={this.state.prestacionesExistentes && this.state.prestacionesExistentes.length > 0}
          >
            <div>
              <span>
                La prestación ya existe en todas las combinaciones seleccionadas. Si lo desea, puede buscar esta prestación y editarla.
              </span>
            </div>
          </Dialog>
        }

        <Dialog
          key="dialogInfo"
          id="dialogInfo"
          actions={
            <FlatButton
              label="Aceptar"
              primary
              onClick={() => this.setState({ infoAlert: false })}
            />
          }
          modal
          open={this.state.infoAlert}
          style={{ width: "700px", fontSize: "13px" }}
          title={
            <div>
              <div style={{ float: "right" }}>
                <IconButton onClick={() => this.setState({ infoAlert: false })} >
                  <i className="material-icons" style={{ color: "#fff" }}>close</i>
                </IconButton>
              </div>
            </div>
          }
        >
          {this.state.infoMensaje}
        </Dialog>
      </div>
    );
  }
}


NuevaPrestacionForm.propTypes = {
  rutInstitucion: PropTypes.number.isRequired,
  // isapre: PropTypes.string.isRequired,
  aceptaGuardadoModalAgregacion: PropTypes.bool.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  valorHosp: PropTypes.string.isRequired,
  valorAmb: PropTypes.string.isRequired,
  valorHospErr: PropTypes.string.isRequired,
  valorAmbErr: PropTypes.string.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  tiposUnidad: PropTypes.array.isRequired,
  itemsImed: PropTypes.array.isRequired,
  tiposProfesionales: PropTypes.array.isRequired,
  pertenenciasFonasa: PropTypes.array.isRequired,
  detallePrestacion: PropTypes.any.isRequired,
  prestacionesSeleccionadas: PropTypes.array.isRequired,
  valorMaxPres: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  CambiosSinGuardar: PropTypes.func.isRequired,
  tipoUnidadReplicar: PropTypes.string.isRequired,
  prestacionesSolicitud: PropTypes.array.isRequired,
  codigoFonasaLoading: PropTypes.bool.isRequired,
  validarGuarismo: PropTypes.bool.isRequired,
  ENV: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => ({
  rutInstitucion: state.global.rutInstitucion,
  // isapre: state.global.isapre,
  aceptaGuardadoModalAgregacion: state.nuevaPrestacionForm.aceptaGuardadoModal,
  tiposArancel: state.nuevaPrestacionForm.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  valorHosp: state.nuevaPrestacionForm.valorHosp,
  valorAmb: state.nuevaPrestacionForm.valorAmb,
  valorHospErr: state.nuevaPrestacionForm.valorHospErr,
  valorAmbErr: state.nuevaPrestacionForm.valorAmbErr,
  tiposPrestaciones: state.global.tiposPrestacionesIsapre,
  tiposUnidad: state.global.tiposUnidad,
  itemsImed: state.global.itemsImed,
  tiposProfesionales: state.global.tiposProfesionales,
  pertenenciasFonasa: state.global.pertenenciasFonasa,
  prestacionesSeleccionadas: state.nuevaPrestacionForm.prestacionesSeleccionadas,
  tipoUnidadReplicar: state.nuevaPrestacionForm.tipoUnidadReplicar || "",
  valorMaxPres: state.nuevaPrestacionForm.valorMaxPres,
  detallePrestacion: {
    codigoPrestacionPrestador: state.nuevaPrestacionForm.detallePrestacion.codigoPrestacionPrestador,
    tipoPrestacion: state.nuevaPrestacionForm.detallePrestacion.tipoPrestacion,
    pabellonPrestacion: state.nuevaPrestacionForm.detallePrestacion.pabellonPrestacion,
    tipoUnidad: state.nuevaPrestacionForm.detallePrestacion.tipoUnidad,
    glosaPrestacionPrestador: state.nuevaPrestacionForm.detallePrestacion.glosaPrestacionPrestador,
    codigoFonasa: state.nuevaPrestacionForm.detallePrestacion.codigoFonasa,
    itemImed: state.nuevaPrestacionForm.detallePrestacion.itemImed,
    tipoProfesional: state.nuevaPrestacionForm.detallePrestacion.tipoProfesional,
    grupoPrestacionIsapre: state.nuevaPrestacionForm.detallePrestacion.grupoPrestacionIsapre,
    codigoPrestacionIsapre: state.nuevaPrestacionForm.detallePrestacion.codigoPrestacionIsapre,
    glosaPrestacionIsapre: state.nuevaPrestacionForm.detallePrestacion.glosaPrestacionIsapre,
    montoArancelPrestacion: state.nuevaPrestacionForm.detallePrestacion.montoArancelPrestacion,
    inicioVigenciaArancel: state.nuevaPrestacionForm.detallePrestacion.inicioVigenciaArancel,
    tipoAtencion: state.nuevaPrestacionForm.detallePrestacion.tipoAtencion,
    pertenenciaFonasa: state.nuevaPrestacionForm.detallePrestacion.pertenenciaFonasa,

    codigoPrestacionPrestadorErr: state.nuevaPrestacionForm.detallePrestacion.codigoPrestacionPrestadorErr,
    tipoPrestacionErr: state.nuevaPrestacionForm.detallePrestacion.tipoPrestacionErr,
    pabellonPrestacionErr: state.nuevaPrestacionForm.detallePrestacion.pabellonPrestacionErr,
    tipoUnidadErr: state.nuevaPrestacionForm.detallePrestacion.tipoUnidadErr,
    glosaPrestacionPrestadorErr: state.nuevaPrestacionForm.detallePrestacion.glosaPrestacionPrestadorErr,
    codigoFonasaErr: state.nuevaPrestacionForm.detallePrestacion.codigoFonasaErr,
    itemImedErr: state.nuevaPrestacionForm.detallePrestacion.itemImedErr,
    tipoProfesionalErr: state.nuevaPrestacionForm.detallePrestacion.tipoProfesionalErr,
    grupoPrestacionIsapreErr: state.nuevaPrestacionForm.detallePrestacion.grupoPrestacionIsapreErr,
    codigoPrestacionIsapreErr: state.nuevaPrestacionForm.detallePrestacion.codigoPrestacionIsapreErr,
    glosaPrestacionIsapreErr: state.nuevaPrestacionForm.detallePrestacion.glosaPrestacionIsapreErr,
    montoArancelPrestacionErr: state.nuevaPrestacionForm.detallePrestacion.montoArancelPrestacionErr,
    inicioVigenciaArancelErr: state.nuevaPrestacionForm.detallePrestacion.inicioVigenciaArancelErr,
    tipoAtencionErr: state.nuevaPrestacionForm.detallePrestacion.tipoAtencionErr,
    pertenenciaFonasaErr: state.nuevaPrestacionForm.detallePrestacion.pertenenciaFonasaErr,

    codigoFonasaValid: state.nuevaPrestacionForm.detallePrestacion.codigoFonasaValid,
    codigoFonasaGlosa: state.nuevaPrestacionForm.detallePrestacion.codigoFonasaGlosa,
  },
  prestacionesSolicitud: state.grillaSolicitud.prestacionesSolicitud,
  codigoFonasaLoading: state.nuevaPrestacionForm.codigoFonasaLoading,
  validarGuarismo: state.nuevaPrestacionForm.validarGuarismo,
  ENV: state.global.ENV,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(NuevaPrestacionForm);

